module.exports = __webpack_public_path__ + "assets/img/mail.030854b5.png";